export const IMAGE_MINIMAP_MAX_EDGE_PX = 168;

const IMAGE_MINIMAP_MIN_EDGE_PX = 1;

type GetImageMinimapSizeParams = {
  maxEdge?: number;
  naturalHeight: number;
  naturalWidth: number;
};

export type ImageMinimapSize = {
  height: number;
  width: number;
};

export const getImageMinimapSize = ({
  maxEdge = IMAGE_MINIMAP_MAX_EDGE_PX,
  naturalHeight,
  naturalWidth,
}: GetImageMinimapSizeParams): ImageMinimapSize | null => {
  if (
    !Number.isFinite(naturalHeight) ||
    !Number.isFinite(naturalWidth) ||
    !Number.isFinite(maxEdge) ||
    naturalHeight <= 0 ||
    naturalWidth <= 0 ||
    maxEdge < IMAGE_MINIMAP_MIN_EDGE_PX
  ) {
    return null;
  }

  if (naturalWidth >= naturalHeight) {
    return {
      height: Math.max(IMAGE_MINIMAP_MIN_EDGE_PX, Math.round((naturalHeight / naturalWidth) * maxEdge)),
      width: maxEdge,
    };
  }

  return {
    height: maxEdge,
    width: Math.max(IMAGE_MINIMAP_MIN_EDGE_PX, Math.round((naturalWidth / naturalHeight) * maxEdge)),
  };
};
